import { render } from "./view-evaluation.vue?vue&type=template&id=3f0fd2ac"
import script from "./view-evaluation.vue?vue&type=script&lang=js"
export * from "./view-evaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__